// extracted by mini-css-extract-plugin
module.exports = {"started":"styles_started__Wfugm","btns":"styles_btns__1Ez9n"};